import { Helmet } from 'react-helmet';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Container,
  Card,
  CardContent,
  TextField,
  SvgIcon,
  InputAdornment,
  Typography,
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { Search as SearchIcon } from "react-feather";
import Modal from "@material-ui/core/Modal";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  SEARCH_ITEMID_API,
  SEARCH_EVENTID_API,
  SEARCH_ACCOUNT_KEY,
  GET_COMMENT_API,
  DELETE_COMMENT_API,
  DELETE_NTF_API,
  SEARCH_ACCOUNT_BLOCK,
  BLOCK_ITEM_API,
} from "../../apiContants";

/* eslint-disable camelcase */

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  mui: {
    border: "1px!important",
    color: "red!important",
    height: "25px!important",
    paddingTop: "5px!important",
  },
  padding: {
    paddingTop: "15px!important",
  },
  buttonsearch: {
    marginTop: "15px!important",
    marginLeft: "15px!important",
  },
  buttonclear: {
    marginTop: "15px!important",
  },
  buttonshow: {
    display: "flex",
    justifyContent: "flex-end",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    backgroundColor: "#5664d2!important",
    color: "white!important",
    borderRadius: "0px!important",
  },
  papervalue: {
    padding: theme.spacing(2),
    border: "1px solid blue!important",
    textAlign: "center",
    color: "black!important",
    borderRadius: "0px!important",
  },
  modal: {
    position: "absolute",
    width: 700,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
  },
}));
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
const Item = () => {
  const classes = useStyles();
  const [reg, regSet] = useState(Array);
  const [regComment, regCommentSet] = useState(Array);
  const [value, setValues] = React.useState({
    name: "",
  });
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [alert, setAlert] = useState(null);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleChangeForm = (name) => (event) => {
    setValues({ ...value, [name]: event.target.value });
  };

  const dynamicSearch = async () => {
    const query = window.location.href;
    const result = query?.substring(query.indexOf("="));
    const hasNumber = /\d/;
    const hasNumberCheck = hasNumber.test(query);
    if (query.indexOf("id") > 0) {
      try {
        const getid = await axios.get(SEARCH_EVENTID_API + result);
        const regs = getid.data;
        regSet(regs);
      } catch {
        console.log("Error loaidng rejected data");
      }
    }
  };

  const handleKeyPress = async (event) => {
    if (event.charCode === "13") {
      const total_mint = await axios.get(SEARCH_ACCOUNT_KEY + value.name);
      const data = total_mint.data.accounts[0];
      regSet(data);
    }
  };
  const totalmint_volume = async () => {
    const WalletAddress = await axios.get(SEARCH_ACCOUNT_BLOCK);
    axios
      .get(SEARCH_ITEMID_API + value.name)
      .then((res) => {
        console.log(res);
        const data = res.data;
        regSet(data);
        if (data?.id) {
          const listAccountBlock = WalletAddress.data.accounts;
          const listAccountBlockTemp = listAccountBlock?.filter(
            (x) => x.address === data?.creator_acc?.address
          );
          if (listAccountBlockTemp.length > 0) {
            setOpenAlert(true);
            setAlert("This user has been restricted !");
          } else {
            regSet(data);
            axios.get(GET_COMMENT_API + value.name).then((ret) => {
              console.log("comment", ret);
              regCommentSet(ret.data.comments);
            });
          }
        }
      })
      .catch((error) => {
        setAlert("Item ID is not valid !");
        setOpenAlert(true);
      });
  };

  const blockItem = async () => {
    axios
      .put(BLOCK_ITEM_API + value.name)
      .then((res) => {
        setOpenAlert(true);
        setAlert("Block Item success !");
      })
      .catch((error) => {
        setAlert("Block Item Error!");
        setOpenAlert(true);
      });
  };
  const deleteItem = async () => {
    try {
      if (value.name) {
        axios
          .delete(DELETE_NTF_API + value.name.toString())
          .then((res) => {
            setOpenAlert(true);
            setAlert("Delete Item success !");
            window.location.reload(true);
          })
          .catch((error) => {
            setAlert("Delete Item Error!");
            setOpenAlert(true);
          });
      }
    } catch {
      console.log("delete error");
    }
  };
  const clear = () => {
    regSet(undefined);
  };
  useEffect(() => {
    dynamicSearch();
  }, []);
  const DeleteComment = async (id, accountid) => {
    axios
      .put(DELETE_COMMENT_API + id + `&account_id=${accountid}`)
      .then((res) => {
        setOpenAlert(true);
        setOpen(false);
        setAlert("Delete Comment success !");
      })
      .catch((error) => {
        setAlert("Delete Comment Error!");
        setOpenAlert(true);
      });
  };
  const body = (
    <Box textAlign="center">
      <div style={modalStyle} className={classes.modal}>
        <h2>Comment manager</h2>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            pb: 3,
          }}
        ></Box>
        <PerfectScrollbar>
          <Box sx={{ maxWidth: 650 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>User</TableCell>
                  <TableCell>Comment</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {regComment.map((customer, idx) => (
                  <TableRow hover key={customer.id}>
                    <TableCell>{customer.account.username.String}</TableCell>
                    <TableCell>{customer.content}</TableCell>
                    <TableCell>
                      <Button
                        type="button"
                        onClick={() =>
                          DeleteComment(customer.id, customer.account_id)
                        }
                      >
                        Delete
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </PerfectScrollbar>
      </div>
    </Box>
  );
  const AlertNotice = (
    <>
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Alert
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          <span>{alert}</span>
        </Typography>
        <Typography id="modal-modal-footer" sx={{ mt: 2 }}>
          <Button
            className="cancel_button"
            color="primary"
            variant="contained"
            style={{ float: "right" }}
            onClick={() => setOpenAlert(false)}
          >
            Close
          </Button>
        </Typography>
      </Box>
    </>
  );
  return (
    <>
      <Helmet>
        <title>Customers | Material Kit</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <Box sx={{ mt: 3 }}>
            <Card>
              <CardContent>
                <Box sx={{ maxWidth: 800 }}>
                  <Grid spacing={3} container>
                    <Grid className={classes.padding} item xs={8}>
                      <TextField
                        // onClick={() => totalmint_volume()}
                        onChange={handleChangeForm("name")}
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SvgIcon fontSize="small" color="action">
                                <SearchIcon />
                              </SvgIcon>
                            </InputAdornment>
                          ),
                        }}
                        placeholder="Enter the item ID"
                        variant="outlined"
                      >
                        1
                      </TextField>
                    </Grid>
                    <Grid className={classes.padding} item xs={4}>
                      <Button
                        className={classes.buttonclear}
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={() => clear()}
                      >
                        Clear
                      </Button>
                      <Button
                        className={classes.buttonsearch}
                        type="button"
                        variant="contained"
                        color="primary"
                        onKeyPress={handleKeyPress}
                        onClick={() => totalmint_volume()}
                      >
                        Search
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </CardContent>
            </Card>
          </Box>
          <Box sx={{ pt: 3 }}>
            {/* <CustomerListResults customers={customers} /> */}
            <Grid spacing={1} container>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Item ID</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  {reg?.id ? reg.id : "----"}
                </Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Creator</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  {reg?.creator_acc?.address ? reg.creator_acc.address : "----"}
                </Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Owner</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  {reg?.owner?.address ? reg.owner.address : "----"}
                </Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Media</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  {reg?.upload_file ? reg.upload_file : "----"}
                </Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>History</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>----</Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Item's Name</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  {reg?.title ? reg.title : "----"}
                </Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Item's price</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  {reg?.instant_sale_price
                    ? reg.instant_sale_price + reg.quote_token
                    : "----"}
                </Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Item's Category</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  {reg?.categories ? reg.categories : "----"}
                </Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Item’s Description</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  {reg?.description ? reg.description : "----"}
                </Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Item’s status</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>----</Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Comment</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  <Button onClick={handleOpen}>Comment Manager</Button>
                </Paper>
              </Grid>
            </Grid>
            {reg.id && (
              <div className="Blocked_button_item">
                <Button
                  onClick={() => blockItem()}
                  type="button"
                  variant="contained"
                  color="primary"
                >
                  Block this item
                </Button>
                <Button
                  onClick={() => deleteItem()}
                  type="button"
                  variant="contained"
                  color="primary"
                >
                  Delete
                </Button>
              </div>
            )}
          </Box>
        </Container>
      </Box>
      <Box textAlign="center">
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          {body}
        </Modal>
      </Box>
      <Modal
        open={openAlert}
        onClose={() => setOpenAlert(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        {AlertNotice}
      </Modal>
    </>
  );
};

export default Item;
